import type { DisplayCardEntry } from '@source-components-react/types';
import { displayCardEntry as rTextCardEntry } from '../components/r-text/display-card-entry';
import { displayCardEntry as cloudinaryAdvancedImageCardEntry } from '../components/cloudinary-advanced-image/display-card-entry';
import { displayCardEntry as rVideoCardEntry } from '../components/r-video/display-card-entry';
import { displayCardEntry as rIconCardEntry } from '../components/r-icon/display-card-entry';
import { displayCardEntry as rButtonCardEntry } from '../components/r-button/display-card-entry';
import { displayCardEntry as rDividerCardEntry } from '../components/r-divider/display-card-entry';
import { displayCardEntry as rEmbedCardEntry } from '../components/r-embed/display-card-entry';
import { displayCardEntry as rListCardEntry } from '../components/r-list/display-card-entry';
import { displayCardEntry as rAccordionCardEntry } from '../components/r-accordion/display-card-entry';
import { displayCardEntry as rMountCardEntry } from '../components/r-mount/display-card-entry';

export const cardEntries: DisplayCardEntry[] = [
  rTextCardEntry,
  cloudinaryAdvancedImageCardEntry,
  rVideoCardEntry,
  rIconCardEntry,
  rButtonCardEntry,
  rDividerCardEntry,
  rEmbedCardEntry,
  rListCardEntry,
  rAccordionCardEntry,
  rMountCardEntry,
];
